import { IExtraInfo, ILayerProps, ITextLayerProps, LayerType } from '@/version-types';
import { IClipboardData, IClipboardLayer } from './types';

/**
 * ai ppt套版 复制图层时，去掉打标信息，避免干扰正常的页面套版
 * @param layer - 图层属性
 */
export const removeAIPPTExtraInfo = (layer: ILayerProps | IExtraInfo) => {
    if (layer.extraInfo?.label?.isOld) {
        delete layer.extraInfo?.label?.isOld;
    }

    if (layer.extraInfo?.label?.canReplace) {
        delete layer.extraInfo?.label?.canReplace;
    }
};

/**
 * ATTENTION: 如果自定义剪贴板中和系统剪贴板都有数据，同时系统剪贴板的文本内容跟当前复制的图层的文本内容不一样，则优先使用系统剪贴板
 * 这样的目的是为了避免在自定义剪贴板有数据的情况下，无法粘贴系统剪贴板的文本内容
 */
export const isUseSystemClipboard = (clipboardData: IClipboardData) => {
    if (!clipboardData.template && clipboardData.text) return true;
    if (!clipboardData.template || !clipboardData.text) return false;

    const isMultiStageFormat = Array.isArray(clipboardData.template);

    // 粘贴纯文本优先
    if (isMultiStageFormat && clipboardData.text) {
        return true;
    }

    // 粘贴纯文本优先
    const layerPasted = clipboardData.template as IClipboardLayer;

    if (
        clipboardData.text &&
        ((layerPasted.layer.layerType === LayerType.TEXT_LAYER &&
            (layerPasted.layer.data as ITextLayerProps)?.text !== clipboardData.text) ||
            layerPasted.layer.layerType !== LayerType.TEXT_LAYER)
    ) {
        return true;
    }

    return false;
};
